import Copy from 'assets/img/icons/copy.svg';
import Button from 'components/_parts/atoms/button';
import CustomTable from 'components/_parts/atoms/table';
import dayjs from 'dayjs';
import { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { toast } from 'react-toastify';
import LoadingCustom from 'components/layouts/loading/loading';
import { useOuterClick } from 'providers/OutsideClick';
import { DirectorateType } from 'components/types/backOffice/company';
import ModalActivityType from '../modal';
import ModalRegion from '../modal';

interface PropTypes {
  t: (e:string) => string
}

const customStyles = {
  headCells: {
    style: {
      fontSize: '12px',
      fontWeight: 'bold',
      textAlign: 'center',
      fontFamily: 'Quicksand',
      padding: '0px',
      justifyContent: 'start',
    },
  },
  cells: {
    style: {
      padding: '0px',
      justifyContent: 'start',
    },
  },
  rows: {
    style: {
      fontFamily: 'Quicksand',
      minHeight: '35px', // override the row height
      borderRadius: 0,
      filter: 'none',
      borderBottom: 'unset !important',
    },
  },
};
const CustomTableMod = styled.div`
  [data-column-id="1"] {
    min-width: 10%;
    tex-align: left;
  }
  .rdt_TableBody {
    height: 500px;
    overflow: auto;
  }
`;

const ButtonMod = styled(Button)`
  width: 100%;
  width: 92px;
  height: 40px;
  float: right;
`;
const ButtonEdit = styled(Button)`
  width: 100%;
  max-width: 70px;
  height: 24px;
  float: right;
`;
const ButtonCopyID = styled(Button)`
  width: 100%;
  width: 37px;
  height: 24px;
  float: right;
  background-color: #9aff5b;
`;

function Index(props: PropTypes) {
  const { t } = props;
  const [showModal, setShowModal] = useState(false);
  const [dataEdit, setDataEdit] = useState<DirectorateType>(null);
  const [typeForm, setTypeForm] = useState('');
  const [id, setId] = useState(null);
  const { directorateList, keyDirectorate } = useSelector((state) => ({
    directorateList: state?.organization?.list_directorate,
    keyDirectorate: state?.loading?.listKey?.companyDirectorate,
  }));
  const innerRef = useOuterClick((e) => {
    if (
      e?.srcElement?.className && (e.srcElement?.className === 'modal fade show'
        || e.srcElement?.className?.includes('cs_modal-bg'))
    ) {
      setShowModal(false);
      setId(null);
    }
  });

  const actionID = (id:string) => (
    <ButtonCopyID
      func={() => {
        navigator.clipboard
          .writeText(id)
          .then(() => {
            toast.success('ID Copied!');
          })
          .catch(() => {
            toast.error('ID Not Copied!');
          });
      }}
    >
      <span>
        <img src={Copy} alt="copy_id" />
      </span>
    </ButtonCopyID>
  );

  const actionEdit = (data:DirectorateType, i: number) => (
    <ButtonEdit
      icon="edit"
      func={() => {
        setShowModal(true);
        setDataEdit(data);
        setTypeForm('edit');
        setId(i);
      }}
    >
          &nbsp;&nbsp;
      {t('org.structure_view.modal.edit')}
    </ButtonEdit>
  );

  const columns = [
    {
      name: 'No',
      sortField: true,
      selector: (_, i) => i + 1,
      cellStyle: { verticalAlign: 'middle' },
      width: 'fit-content',
    },
    {
      name: 'ID',
      sortField: true,
      selector: (row) => actionID(row.directorate_id),
      headerStyle: {
        padding: '0px',
        justifyContent: 'start',
      },
      style: {
        padding: '0px',
        justifyContent: 'start',
      },
      cellStyle: { verticalAlign: 'middle' },
    },
    {
      name: t('company.directorate_name'),
      sortField: true,
      selector: (row) => row.directorate_name,
    },
    {
      name: t('org.index_view.last_update'),
      sortField: true,
      selector: (row) => dayjs(row.updated_at).format('D MMM YYYY') ?? '-',
      center: true,
      width: '20%',
    },
    {
      name: t('org.employee.action'),
      sortField: true,
      style: {
        justifyContent: 'center',
      },
      center: true,
      selector: (row) => 'der',
      width: '15%',
      cell: (row, i) => actionEdit(row, i),
    },
  ];

  return (
    <>
      {showModal && (
      <ModalActivityType
        innerRef={innerRef}
        modal={showModal}
        funcModal={setShowModal}
        ids={id}
        data={dataEdit}
        funcId={() => setId}
        typeForm={typeForm}
        t={t}
      />
      )}
      <div
        className="tab-pane active position-relative"
        id="direcotrate_list"
        role="tabpanel"
        style={{
          minHeight: '700px',
        }}
      >
        {keyDirectorate && (
          <LoadingCustom />
        )}
        {!keyDirectorate && (
        <>
          <div className="row">
            <div className="col-8">
              <h4 className="title">{t('wla.analytics.table.directorate')}</h4>
            </div>
            <div className="col-4">
              <ButtonMod
                icon="create"
                func={() => {
                  setShowModal(true);
                  setDataEdit(null);
                  setTypeForm('create');
                }}
              >
                  &nbsp;&nbsp;
                {t('board.add')}
              </ButtonMod>
            </div>
          </div>
          <CustomTableMod>
            <CustomTable
              columns={columns}
              data={directorateList}
              customStyles={customStyles}
            />
          </CustomTableMod>
        </>
        )}
      </div>
    </>
  );
}

export default Index;
